import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  PredefinedImageInput,
  Props as PredefinedImageInputProps,
} from './PredefinedImageInput';

type Props = Omit<PredefinedImageInputProps, 'value' | 'onChange'> & {
  name: string;
};

export const PredefinedImageInputControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <PredefinedImageInput
          {...props}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
  );
};
